import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { PageviewsettingsService } from '../services/pageviewsettings.service';
import { OrderService } from '../services/order.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { filter } from 'rxjs';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { Title} from '@angular/platform-browser';
import { TenantService } from '../services/tenant.service';
import * as Globals from '../../globals';
import { GiveawaysComponent } from '../giveaways/giveaways.component';
import { URL_INTERCOM_SUPPORT } from 'src/globals';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})

export class LandingPageComponent   {
	@ViewChild('carousel1', { static: false }) carousel1Ref!: ElementRef;
	@ViewChild('carousel', { static: false }) carouselRef!: ElementRef;
	activeIndex = 0;
	activeIndex1 = 0;

	public generalSupportURL: string = URL_INTERCOM_SUPPORT;

	scrollToCard(index: number) {
		const carousel = this.carouselRef.nativeElement as HTMLElement;
		const cardWidth = carousel.children[0].clientWidth + 16; // 16 = spacing
		carousel.scrollTo({ left: index * cardWidth, behavior: 'smooth' });
		this.activeIndex = index;
	}

	scrollToplansCard(index: number) {
		const carousel1 = this.carousel1Ref.nativeElement as HTMLElement;
		const cardWidth = carousel1.children[0].clientWidth + 16; // 16 = spacing
		carousel1.scrollTo({ left: index * cardWidth, behavior: 'smooth' });
		this.activeIndex1 = index;
	}

	getDotClassforplanscard(i: number) {
		return {
			'w-3 h-3 rounded-full': true,
			'bg-purple-500': this.activeIndex1 === i,
			'bg-gray-300': this.activeIndex1 !== i
		};
	}

	getDotClass(i: number) {
		return {
			'w-3 h-3 rounded-full': true,
			'bg-purple-500': this.activeIndex === i,
			'bg-gray-300': this.activeIndex !== i
		};
	}

  
	analytics = AnalyticsBrowser.load({ writeKey: 'J5CQbn6p9ejiR74pkFczF0CKvtfnqMgU' })
	show = true
	@ViewChild('planssection') planssection!: ElementRef;
	isMenuOpen = false;
	// colors: { name: string; color: string }[] = [
	//   { name: "huskymobile", color: "#4b2e83" },
	//   { name: "osumobile", color: "#550000" },
	//   { name: "calmobile", color: "#00008b" },
	//   { name: "hushymobile", color: "#06402b" },
	// ];

	plan: any;
	perks: any;
	features: any;
	loadeddata: any;
	zipCode: string = '';
	coverageForm: FormGroup;
	tenantId: any;
	affiliateId: any;
	facultyEnabled: boolean = false;
	title: Title;
	tenant: TenantService;
    
	toggleMenu() {
		this.isMenuOpen = !this.isMenuOpen;
	}

	faqOpen = {
		faq1: false,
		faq2: false,
		faq3: false,
		faq4: false,
		// ...
	};

	ngAfterViewInit() {
		const carousel = this.carouselRef.nativeElement as HTMLElement;
		const carousel1 = this.carousel1Ref.nativeElement as HTMLElement;
		carousel1.addEventListener('scroll', () => {
			const scrollLeft = carousel1.scrollLeft;
			const cardWidth = carousel1.children[0].clientWidth + 16; // 16px gap (space-x-4)
			const index = Math.round(scrollLeft / cardWidth);
			this.activeIndex1 = index;
		});
		// Listen to scroll events
		carousel.addEventListener('scroll', () => {
			const scrollLeft = carousel.scrollLeft;
			const cardWidth = carousel.children[0].clientWidth + 16; // 16px gap (space-x-4)
			const index = Math.round(scrollLeft / cardWidth);
			this.activeIndex = index;
		});
	}

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private settingsService: PageviewsettingsService,
		private orderservice:OrderService,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private titleService: Title,
		private tenantService: TenantService,
    ) {
		this.title = titleService;
		this.tenant = tenantService;
		

		this.coverageForm = this.fb.group({
			zipCode: ['', [Validators.required, Validators.pattern('^[0-9]{5}$')]]
		});

		this.facultyEnabled = this.tenant.getFacultyVisibility();
		this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe(() => {
			const flag = this.tenant.getFacultyVisibility();
			if (flag !== this.facultyEnabled) {
				this.facultyEnabled = flag;
				this.cdr.detectChanges();
			}
		});

		this.settingsService.getCollegetenantcode(this.tenant.getName()).subscribe(data => {
			this.tenantId = parseInt(data.result.id)
			this.affiliateId = data.result.affiliateId

			this.loadPageSettings();
		});
   
		// this.settingsService.background$.subscribe(bg => this.images.background = bg);
		// this.settingsService.banner$.subscribe(banner =>  this.images.banner = banner);
		// this.settingsService.color$.subscribe(color =>   this.images.color = color)
		// this.analytics.page("Landing page")
    }
    
    checkCoverage() {
		if (this.coverageForm.valid)  {
			this.orderservice.checkCoverage(this.coverageForm.value.zipCode).subscribe({
				next: (response) => {
					// this.isLoading = false;
					// this.router.navigate(['/success']);
				},
				error: (error) => {
					// this.isLoading = false;
					console.error('Order submission failed:', error);
				}
			});
		}      
    }

	scrollToBottom() {
		this.planssection.nativeElement.scrollIntoView({ behavior: 'smooth' });
	}

	gettenantdetails() {

	}

    loadPageSettings() {
      // const affiliateId = 1;  
      // const tenantId = 1;
      // const pageName = 'landingpage';
  
		this.settingsService.getPageViewSettings(this.affiliateId, this.tenantId).subscribe(data => {
			this.loadeddata = data.result;
			this.title.setTitle(this.loadeddata['Name'] + Globals.PAGE_TITLE);
			// console.log(this.loadeddata)
			// this.bgImageUrl = 'assets/landingmainbannerbackground.png'
			// this.updateContent()
			const color = this.loadeddata?.PrimaryColor;
	
			if (color) {
				document.documentElement.style.setProperty('--primary', color);
			} else {
				document.documentElement.style.setProperty('--primary', 'white');
			}
      });
    }

    updateContent(){
    
      this.plan  = {
         
           title: this.loadeddata?.landingperksection2title,
           description:"All backed by T-Mobile’s 5G network.",
           list: [
               {
                 id:this.loadeddata?.landingcard1id,
                 name: this.loadeddata?.landingcard1button1text,
                 title:"I'm a" ,
                 subbreak :"student",
                 description: this.loadeddata?.landingpagecard1subtitle,
                 list1: this.loadeddata?.landingcard1description1,
                 list2:this.loadeddata?.landingcard1description2,
                 list3: this.loadeddata?.landingcard1description3
               },
              //  {
              //    id:this.loadeddata?.landingcard2button1id,
              //    name: this.loadeddata?.landingcard2button1text,
              //    title: this.loadeddata?.landingpagecard2title,
              //    description: this.loadeddata?.landingpagecard2subtitle,
              //    list1: this.loadeddata?.landingcard2description1,
              //    list2:this.loadeddata?.landingcard2description2, 
              //    list3:this.loadeddata?.landingcard2description3
              //  },
               {
                 id:this.loadeddata?.landingcard3id,
                 name:  this.loadeddata?.landingcard3button1text,
                 title: "I'm a Fan or",
                 subbreak: "Alumni",
                 description: this.loadeddata?.landingpagecard3subtitle,
                 list1: this.loadeddata?.landingcard3description1,
                 list2:this.loadeddata?.landingcard3description2,
                 list3: this.loadeddata?.landingcard3description3
               }
             ]
         
       }
 
       this.perks =[
        
           {
             logo: this.loadeddata?.landingperklogo1,
             title: this.loadeddata?.landingperktitle1 ,
             description: this.loadeddata?.landingperkparagragh1,
           },
           {
             logo: this.loadeddata?.landingperklogo2,
             title: this.loadeddata?.landingperktitle2,
             description: this.loadeddata?.landingperkparagragh2
           },
           {
             logo: this.loadeddata?.landingperklogo3,
             title: this.loadeddata?.landingperktitle3,
             description: this.loadeddata?.landingperkparagragh3
           },
           {
             logo: this.loadeddata?.landingperklogo4,
             title: this.loadeddata?.landingperktitle4,
             description: this.loadeddata?.landingperkparagragh4
           }
         
         ]
 
         this.features =[
 
          {
             logo: this.loadeddata?.landingsectionchooseicon1,
             title: this.loadeddata?.landingsectionchoosefeaturetitle1,
             description: this.loadeddata?.landingsectionchoosefeaturedescription1
           },
           {
             logo: this.loadeddata?.landingsectionchooseicon2,
             title: this.loadeddata?.landingsectionchoosefeaturetitle2,
             description: this.loadeddata?.landingsectionchoosefeaturedescription2
           },
           {
             logo: this.loadeddata?.landingsectionchooseicon3,
             title: this.loadeddata?.landingsectionchoosefeaturetitle3,
             description:this.loadeddata?.landingsectionchoosefeaturedescription3
           },
           {
             logo: this.loadeddata?.landingsectionchooseicon4,
             title:this.loadeddata?.landingsectionchoosefeaturetitle4,
             description: this.loadeddata?.landingsectionchoosefeaturedescription4,
           },
           {
             logo: this.loadeddata?.landingsectionchooseicon5,
             title: this.loadeddata?.landingsectionchoosefeaturetitle5,
             description:this.loadeddata?.landingsectionchoosefeaturedescription5
           }
         ]
   }

    exploreplan(value: any) {
      if (value =='Student') {
        this.router.navigate([this.tenant.getName() + '/student']);
        this.analytics.track("landingpage.getastudentplan",);
      } else if (value == 'Faculty') {
        this.router.navigate([this.tenant.getName() + '/shop-faculty-plans']);
        this.analytics.track("landingpage.shopplans",);
      } else if(value == 'Alumni') {
        this.router.navigate([this.tenant.getName() + '/fan']);
        this.analytics.track("landingpage.getafanplan",);
      }
    }

    trackclick(event:any){
      this.analytics.track(event)
    }
}
